import { z } from 'zod';
import { mapPointerSchema } from './map.js';
/**
 * Proves the shared-schema pipeline end to end: apps/api validates its response
 * against this schema before returning, apps/web parses the response with the
 * same schema. Neither side may redefine the shape.
 */
export const healthResponseSchema = z.object({
    ok: z.literal(true),
    version: z.string().min(1),
    /**
     * True when `GRAPH_MODE=live` was asked for and the Graph integration resolved off, so mail
     * and filing are parking (#61). A flag only: which setting is wrong is for the authenticated
     * `GET /api/ops/integrations`, not an anonymous probe. Optional so older builds still parse.
     */
    integrationsDegraded: z.boolean().optional(),
    /**
     * The sections this server package answers for, when it was built with a restricted list (#625):
     * `["roster"]` for a Roster-only server. ABSENT when every section is on, so a server built
     * without the setting answers exactly as it did before. Names only, so that a release can be
     * checked from outside; it says nothing an anonymous caller could not learn from a refusal.
     */
    sections: z.array(z.string().min(1)).optional(),
    /**
     * The map file this server serves, read from its map store's `current.json` (ADR-023 section 4,
     * #746): its name and SHA-256, and nothing else about the store. ABSENT when the server has no map
     * store, no pointer, or a pointer that does not have the one shape. Public map data only.
     */
    map: mapPointerSchema.optional(),
});
//# sourceMappingURL=health.js.map